import { render, staticRenderFns } from "./nave.vue?vue&type=template&id=2642c148&scoped=true"
import script from "./nave.vue?vue&type=script&lang=js"
export * from "./nave.vue?vue&type=script&lang=js"
import style0 from "./nave.vue?vue&type=style&index=0&id=2642c148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642c148",
  null
  
)

export default component.exports